// @flow

export const CHAT_VIEW_MODAL_ID = 'chatView';

/**
 * The size of the chat.
 */
export const CHAT_SIZE = 375;

/**
 * The audio ID of the audio element for which the {@link playAudio} action is
 * triggered when new chat message is received.
 *
 * @type {string}
 */
export const INCOMING_MSG_SOUND_ID = 'INCOMING_MSG_SOUND';

/**
 * The {@code messageType} of error (system) messages.
 */
export const MESSAGE_TYPE_ERROR = 'error';

/**
 * The {@code messageType} of local messages.
 */
export const MESSAGE_TYPE_LOCAL = 'local';

/**
 * The {@code messageType} of remote messages.
 */
export const MESSAGE_TYPE_REMOTE = 'remote';

export const DESKTOP_SMALL_WIDTH_THRESHOLD = 580;

export const MOBILE_SMALL_WIDTH_THRESHOLD = 680;

/**
 * Lobby message type.
 */
export const LOBBY_CHAT_MESSAGE = 'LOBBY_CHAT_MESSAGE';

export const CHAT_TABS = {
    POLLS: 'polls-tab',
    CHAT: 'chat-tab'
};

/**
 * Formatter string to display the message timestamp.
 */
export const TIMESTAMP_FORMAT = 'H:mm';

/**
 * The modes of the buttons of the chat and polls tabs.
 */
export const BUTTON_MODES = {
    CONTAINED: 'contained',
    TEXT: 'text'
};

/**
 * Types of File Name.
 */
export const FILE_NAME = [
    'mp4', 'mkv', 'jpg', 'jpeg', 'png', 'mpeg4', 'gif', 'eps', 'tiff', 'tif', 'mov', 'wmv',
    'avi', 'avchd', 'flv', 'f4v', 'swf', 'webm', 'pdf', 'docx', 'doc', 'psd', 'xls', 'svg', 'xls', 'xlsx', 'ppt', 'pptx', 'odp', 'mp3', 'wav', 'm4a'
];
